import {
    useState,
    forwardRef,
    useImperativeHandle,
} from 'react'
import HideIcon from '../../Icons/HideIcon'
import VisibleIcon from '../../Icons/VisibleIcon'

const maskRegex = /^\*{3}-\*{2}-\d{4}$/

const SsnInput = forwardRef(({ data, title, readOnly }, ref) => {

    const [ssn, setSsn] = useState(data || "")
    const [error, setError] = useState(false)
    const [showSSN, setShowSSN] = useState(false)
    const [customErrorMsg, setCustomErrorMsg] = useState("")

    const isMasked = maskRegex.test(data) && readOnly

    const formatSSN = (value) => {
        const digits = value.replace(/\D/g, '')
        const parts = []

        if (digits.length > 0) parts.push(digits.substring(0, 3))
        if (digits.length > 3) parts.push(digits.substring(3, 5))
        if (digits.length > 5) parts.push(digits.substring(5, 9))

        return parts.join('-')
    }

    const hideValue = (value) => {
        const digits = value.replace(/\D/g, '')
        const parts = []

        if (digits.length > 0) parts.push("*".repeat(Math.min(3, digits.length)))
        if (digits.length > 3) parts.push("*".repeat(Math.min(2, digits.length - 3)))
        if (digits.length > 5) parts.push("*".repeat(Math.min(4, digits.length - 5)))

        return parts.join('-')
    }

    const hidedTextKeyDown = (event) => {
        const key = event.key

        const cursorPos = event.target.selectionStart

        let newText

        if (!isNaN(parseInt(key))) {
            newText = ssn.slice(0, cursorPos) + key + ssn.slice(cursorPos)
        } else if (key === ' ') {

        } else if (key === 'Backspace') {
            if (cursorPos > 0) {
                newText = ssn.slice(0, cursorPos - 1) + ssn.slice(cursorPos)
            }
        } else if (key === 'Delete') {
            if (cursorPos < ssn.length) {
                newText = ssn.slice(0, cursorPos) + ssn.slice(cursorPos + 1)
            }
        }

        if (!newText) {
            return
        }

        setSsn(formatSSN(newText))

    }

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const ssnRegex = /^\d{3}-\d{2}-\d{4}$/
            const validity = ssnRegex.test(ssn)
            setError(!validity)
            setCustomErrorMsg("")
            return {
                isValid: validity,
                value: ssn,
            }
        },
        setError: (err, customMsg) => {
            setError(err)
            setCustomErrorMsg(customMsg || "")
        },
    }))

    return (
        <div>
            <label className="block text-sm font-medium text-gray-700 ">{title}</label>
            <div className="relative">
                <input
                    type={"text"}
                    value={showSSN ? ssn : isMasked ? "***-**-****" : hideValue(ssn)}
                    onChange={(e) => showSSN ? setSsn(formatSSN(e.target.value)) : null}
                    onKeyDown={(e) => showSSN ? null : hidedTextKeyDown(e)}
                    maxLength={11}
                    disabled={readOnly}
                    className="block w-full pr-10 pl-3 py-2 rounded-md border border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm mt-1 mb-2"
                    placeholder="123-45-6789"
                />
                <span
                    onClick={() => setShowSSN(!showSSN)}
                    className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-500"
                >
                    {showSSN ? (
                        // Hide ICON
                        <HideIcon />
                    ) : (
                        // VISIBLE ICON
                        <VisibleIcon />
                    )}
                </span>
            </div>
            {error && (
                <p className="mt-1 text-sm text-red-600">
                    {customErrorMsg || "SSN is invalid"}
                </p>
            )}
        </div>
    )
})

export default SsnInput
